// extracted by mini-css-extract-plugin
module.exports = {"pill":"Pills_pill__JMZIS","active":"Pills_active__hDWJt"};